import { createContext } from 'react';
import { Client, ConnectionState } from '@twilio/conversations';
import { ChatUserType } from './types';

export type ChatContextType = {
  userType: ChatUserType;
  userId: string;
  identity: string;
  status: ConnectionState;
  client: Client | undefined;
  error: string | undefined;
};

export const ChatContext = createContext<ChatContextType | undefined>(
  undefined,
);
